import { getDefaultStatisticItem } from '../../utils/utils'

export default {
  statisticScheme: {
    'PT1': getDefaultStatisticItem('statistic.basketball.pt1'),
    'PT2': getDefaultStatisticItem('statistic.basketball.pt2'),
    'PT3': getDefaultStatisticItem('statistic.basketball.pt3'),
    'FOUL': getDefaultStatisticItem('statistic.foul'),
    'TIMEOUT': getDefaultStatisticItem('statistic.timeout')
  },
  statisticEvents: {
    'PT1': 'PT1',
    'PT2': 'PT2',
    'PT3': 'PT3',
    'FOUL': ['FOUL', 'TECHNICAL_FOUL_PLAYER', 'FOUL_U'],
    'TIMEOUT': 'TIMEOUT'
  },
  statisticOrder: [
    'PT1',
    'PT2',
    'PT3',
    'FOUL',
    'TIMEOUT'
  ],
  additionalStatisticBlocks: [
    {
      type: 'shootout',
      component: 'shootout-statistic'
    }
  ]
}
